import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { CompanyBackupCard } from "../features/settings/CompanyBackupCard";

export default function BackupPage() {
  const { t } = useTranslation();
  return (
    <AppShell title={t("nav.backup")} subtitle={t("backups.hint")}>
      <div className="mx-auto max-w-2xl">
        <CompanyBackupCard />
      </div>
    </AppShell>
  );
}
